module.exports = __webpack_public_path__ + "media/images/smile-3-8c04b24df3de8685ddfe368cc20ebe7a.svg";